/* eslint-disable react/jsx-key */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable max-len */
import React from 'react';
import { PriceHandler } from '../../../../../redux/helper/CamelCase';

function DirectOrderSummary({
    OrderDetails,
}) {
    const handleAmount=(value)=>{
        return Number(value)?.toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
        })
    }
    return (
        <div className="lg:min-w-[30%] min-w-full lg:mt-0 mt-4 lg:ml-[17px]">
            <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                <div className="border-b border-[#CBCBCB] pb-2.5">
                    <div className="flex justify-between items-center">
                        <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                        {/* <!-- <p class="font-normal text-xs3 text-[#555259]">Total Order Qty.: 15,000 kg</p> --> */}
                    </div>
                    <p className="sm:text-lg text-base font-normal text-[#555259]">{OrderDetails.order_type}</p>
                </div>
                <div className="mt-3 border-b border-[#CBCBCB]">
                    <p className="text-sm font-semibold text-[#090406]">Quantity</p>
                    <div className="items-center flex justify-between mt-2">
                        <p className="font-normal text-sm text-[#555259]">Line Items selected</p>
                        <p className="font-normal text-sm text-[#555259]">{OrderDetails.total_items}</p>
                    </div>
                    <div className="items-center flex justify-between mt-2 pb-3">
                        <p className="font-normal text-sm text-[#555259]">Net Order Quantity</p>
                        {Object.keys(OrderDetails?.summary?.quantity).length>0 &&
                        Object.keys(OrderDetails?.summary?.quantity).map((UOM,i)=>(
                            <p  style={{float: `${i===0?'':'right'}`}} key={UOM} className={`font-normal text-sm text-[#555259]`}>{Number(OrderDetails?.summary?.quantity[UOM])} {UOM} <br/></p>
                        ))}
                    </div>
                </div>
                <div className="pt-1.5">
                    <div>
                        <p className="sm:text-lg text-base font-semibold text-[#090406]">Order Summary</p>
                        <div>
                            <div
             
                                className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">{
                                        handleAmount(OrderDetails?.summary?.order_value)}</p>
                                </div>
                                <div className="flex justify-between items-center sm:pb-1 py-2">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal flex items-center">
                                        Discount
                                    </p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">- {Number(OrderDetails?.summary?.total_discount).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })||0.00}</p>
                                </div>
                            </div>
                            <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Net Amount</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                        { handleAmount(OrderDetails?.summary?.order_net_amount)}
                                    </p>
                                </div>
                            </div>
                            <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST <span>{`(18%)`}</span></p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                        {handleAmount(Number(OrderDetails?.summary?.order_gst?.gst))}
                                    </p>
                                </div>
                            </div>
                            <div className="sm:pr-1 sm:pl-2 border-b border-[#CBCBCB] py-1">
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                                    <p className="md:text-xs4 text-base font-semibold text-[#000000]">{handleAmount(Number(OrderDetails?.summary?.order_gross_amount))}
                                    </p>
                                </div>
                            </div>
                            <div className='pt-2'>
                                <p className="font-normal text-xs3 text-[#FF3B30] mt-1.5"><span className="text-[#FF3B30]">*</span>Taxes & Duties are subject to change as per Government guidelines and will be charged as applicable at the time of dispatch</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default DirectOrderSummary;
